const $$splitComponentImporter = () => import('/src/src/routes/_authenticated/_feature_announcement/admin/manage/folders.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";
export const Route = createFileRoute("/_authenticated/_feature_announcement/admin/manage/folders")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(z.object({
    search: z.string().optional(),
    folderIds: z.any().optional()
  })),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "Resources",
      description: "Page title"
    })
  }
});